<template>
  <div>
    <div>
      <div class="flexc-cen-x fixed">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>财务</el-breadcrumb-item>
          </el-breadcrumb>
          <el-select v-if="DianList.length>1" style="margin-left:20px;width:140px" size="mini" v-model="SelectStoresID" @change="changedian()" placeholder="门店">
              <el-option
                      v-for="item in DianList"
                      :key="item.ID"
                      :label="item.StoresName"
                      :value="item.ID">
              </el-option>
          </el-select>
      </div>
  <el-form :inline="true" :model="formInline"  style="display:flex;flex-wrap:wrap;padding-top:30px">
         <el-form-item label="搜索：">
          <el-input size="mini" placeholder="请输入姓名/手机号" v-model="selectNmae"  auto-complete="off"></el-input>
         </el-form-item>
        <el-form-item label="时间:">
            <el-date-picker
              v-model="tdate"
              type="date"
              placeholder="选择日期"
              size="mini"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              style="width:170px"
              >
            </el-date-picker>
                至
            <el-date-picker
              v-model="mdate"
              type="date"
              placeholder="选择日期"
              size="mini"
              style="width:170px"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              >
            </el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="场地："  prop="Site">
            <el-select v-model="Site" clearable placeholder="请选择" size="mini">
                  <el-option
                    v-for="item in siteList"
                    :key="item.ID"
                    :label="item.SiteName"
                    :value="item.ID">
                  </el-option>
                </el-select>
        </el-form-item>
        <el-form-item label="项目：" prop="objID">
            <el-select clearable v-model="objID" placeholder="请选择" size="mini">
                  <el-option
                    v-for="item in projectList"
                    :key="item.ID"
                    :label="item.ProjectName"
                    :value="item.ID">
                  </el-option>
                </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="服务人员：" prop="LoginID">
            <el-select clearable v-model="LoginID" placeholder="请选择" size="mini">
                  <el-option
                    v-for="item in projectList"
                    :key="item.ID"
                    :label="item.ProjectName"
                    :value="item.ID">
                  </el-option>
                </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-button size="mini" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          <!-- <el-button size="mini" @click="noSearch">置空</el-button> -->
        </el-form-item>
    </el-form>
        <!-- <span style="font-size:14px;margin-left:20px">搜索：</span>
        <el-input size="mini"  placeholder="输入部门名称" style="width:200px"></el-input>
        <el-button size="small" type="primary"  style="margin-left:20px" icon="el-icon-search" @click="search">搜索</el-button> -->
  </div>


    <el-table :data="tableData" highlight-current-row size="mini" v-loading="loading"  element-loading-text="拼命加载中" style="width:100%;margin-top:10px">
          <el-table-column  prop="OrderCode" label="订单号"  width="150">
          </el-table-column>
          <el-table-column  prop="TcStaffTypeID" label="订单价格" align="center" >
            <template slot-scope="scope">
              <div class="flex-xy">
                   ￥{{scope.row.OrderPrice}} 
              </div>

            </template>
          </el-table-column>
          <el-table-column  prop="SFPrice" label="实付金额" align="center" >
            <template slot-scope="scope">
              <div class="flex-xy">
                   ￥{{scope.row.SFPrice}} 
              </div>
            </template>
          </el-table-column>
          <el-table-column  prop="YHPrice" label="优惠金额"  align="center">
            <template slot-scope="scope">
              <div class="flex-xy">
                   ￥{{scope.row.YHPrice}} 
              </div>
            </template>
          </el-table-column>
          <el-table-column  prop="MaLingPrice" label="抹零金额"  align="center">
            <template slot-scope="scope">
              <div class="flex-xy">
                   ￥{{scope.row.MaLingPrice}} 
              </div>
            </template>
          </el-table-column>
          <el-table-column  prop="MemberName" label="顾客名称" align="center" >
          </el-table-column>
          <el-table-column  prop="addTime" label="下单时间" align="center" width="150" >
          </el-table-column>
          <el-table-column  prop="state" label="状态" align="center" >
          </el-table-column>
          <el-table-column  prop="Note" label="备注" align="center" >
          </el-table-column>
          <el-table-column align="center" label="操作" width="380"  fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="handleEdit(scope.row)">详情</el-button>
              <el-button size="mini" v-if="q1 == true" type="warning" plain  @click="hexiao(scope.row)">业务归属</el-button>
              <el-button size="mini" v-if="q2 == true" type="success" plain   @click="toNote(scope.row)" >修改备注</el-button>
              <el-button type="info" v-if="q3 == true" size="mini" @click="delDan(scope.row)">删除</el-button>
            </template>
        </el-table-column>
    </el-table>
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!--列表-->

    <!-- 分页组件 -->
    
    <!-- 编辑界面 -->
    <el-drawer :wrapperClosable= false title="详情" :visible.sync="editFormVisible" :direction="direction" size="40%">
      <!-- <div class="bottomBORD">
        <div style="margin-left:2%;font-size:15px">订单信息</div>
          <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:30px">
              <div style="color:#7e7e7e;width:80px">状态：</div>
              <div> <span class="Info" v-if="mainList.state == 0">
                    学员取消
                  </span>
                  <span class="coBlue" v-if="mainList.state == 1">
                   已预约
                  </span>
                  <span class="Success" v-if="mainList.state == 2">
                    已核销
                  </span>
                  <span class="Danger" v-if="mainList.state == 3">
                   未到
                  </span>
                  <span class="Info" v-if="mainList.state == 4">
                    机构取消
                  </span>
                  <span class="Warning" v-if="mainList.state == 5">
                   请假
                  </span>
              </div>
          </div>
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">订单号：</div>
                  <div class="flexc-cen-x">
                   
                    <div style="margin-left:5px;font-size:13px">{{mainList.OrderCode}}</div>
                  </div>
    
               
            </div>
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">订单金额：</div>
                    <div class="flexc-cen-x">
                 
                    <div style="margin-left:5px;font-size:13px">￥{{mainList.OrderPrice}}</div>
                  </div>
            </div>
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">实付金额：</div>
                  <div class="flexc-cen-x">
                    <div style="margin-left:5px;font-size:13px">￥{{mainList.SFPrice}}</div>
                  </div>
    
               
            </div>
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">优惠金额：</div>
                  <div class="flexc-cen-x">
                    <div style="margin-left:5px;font-size:13px">￥{{mainList.YHPrice}}</div>
                  </div>
            </div>

           
      </div> -->
      <div class="bottomBORD" style="margin-top:10px">
        <div style="margin-left:2%;font-size:15px">顾客信息</div>
        
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:30px">
                  <div style="color:#7e7e7e;width:80px">姓名：</div>
                    <div class="flexc-cen-x">
                     
                    <div style="margin-left:5px;font-size:13px">{{mainList.MemberName}}</div>
                  </div>
            </div>
            <div v-if="mainList.MembersID !=0" class="flexc-cen-x"  style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">{{WZHYName}}编号：</div>
                    <div class="flexc-cen-x">
                     
                    <div style="margin-left:5px;font-size:13px">{{mainList.MemberCard}}</div>
                  </div>
            </div>
            <div v-if="mainList.MembersID !=0" class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">{{WZHYName}}等级：</div>
                    <div class="flexc-cen-x">
                     
                    <div style="margin-left:5px;font-size:13px">{{mainList.LevelName}}</div>
                  </div>

            </div>

            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">下单时间：</div>
                  <div class="flexc-cen-x">
                    <div style="margin-left:5px;font-size:13px">{{mainList.addTime}}</div>
                  </div>
            </div>


      </div>
      <div class="" style="margin-top:30px;" >
        <div style="margin-left:2%;font-size:15px;margin-bottom:30px">支付详情</div>
          <el-table :data="mainList.listPayOrderInfo" highlight-current-row v-loading="loading" size="mini"  style="width:100%;margin-top:20px">
              <el-table-column  prop="OrderCode" label="支付类型"  align="center">
                 <template slot-scope="scope">
                  <span class="flex-xy" v-if="scope.row.PayType == 1">
                      现金
                  </span>
                  <span class="flex-xy" v-if="scope.row.PayType == 2">
                      银行卡
                  </span>
                  <span class="flex-xy" v-if="scope.row.PayType == 3">
                     微信
                  </span>
                  <span class="flex-xy" v-if="scope.row.PayType == 4">
                      支付宝
                  </span>
                  <span class="flex-xy" v-if="scope.row.PayType == 5">
                      储蓄卡
                  </span>
                  <span class="flex-xy" v-if="scope.row.PayType == 6">
                      次卡
                  </span>
                  <span class="flex-xy" v-if="scope.row.PayType == 7">
                      会员卡
                  </span>
                  <span class="flex-xy" v-if="scope.row.PayType == 8">
                      其他
                  </span>
                </template>
              </el-table-column>
              <el-table-column  prop="PayAmount" label="支付金额"  align="center"></el-table-column>
          </el-table>
      </div>
      <div class="" style="margin-top:30px;margin-bottom:100px" >
        <div style="margin-left:2%;font-size:15px;margin-bottom:30px">购物详情</div>
          <el-table :data="mainList.listPayOrderObj" highlight-current-row v-loading="loading" size="mini"   style="width:100%;margin-top:20px">
              <el-table-column  prop="OrderCode" label="类型"  align="center">
                 <template slot-scope="scope">
                  <span class="flex-xy" v-if="scope.row.objtype == 1">
                    项目
                  </span>
                  <span class="flex-xy" v-if="scope.row.objtype == 2">
                    商品
                  </span>
                 </template>
              </el-table-column>
              <el-table-column  prop="CommodityName" label="名称"  align="center"></el-table-column>
              <el-table-column  prop="Specname" label="规格"  align="center"></el-table-column>
              <el-table-column  prop="objCount" label="数量"  align="center"></el-table-column>
              <el-table-column  prop="objPrice" label="单价"  align="center"></el-table-column>
              <el-table-column  prop="objallPrice" label="总价"  align="center"></el-table-column>
          </el-table>
      </div>
        <div class="demo-drawer__footer flex-r-x"  style="width:40%">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
           
            @click="closeDialog"
            >确定</el-button
          >
        </div>
    </el-drawer>

  <el-dialog title="选择业务归属" :visible.sync="hexiaoShow" width="40%">

      <el-form label-width="120px" >
        <el-form-item :label="WZYGName+'：'" prop="LoginIDs" >
            <div class="flexc-cen-x" style="width:100%">
                <div style="display:flex;flex-wrap:wrap;">
                    <div  style="margin-left:5px">
                        {{personName}}
                    </div>
                </div>
                <div>
                    <el-button  @click="toPerson()" type="text" style="margin-right:10px;margin-left:20px">选择</el-button>
                </div>   
            </div>        
        </el-form-item>
        <!-- <el-form-item label="使用核销码:" prop="isCode">
          <el-radio-group v-model="isCode">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="核销码" prop="number" v-if="isCode == 1">
          <el-input size="small" placeholder="请输码" v-model="code"  auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="核销金额" prop="number" v-if="mainList.vipID == -1 && isCode == 0">
          <el-input size="small" placeholder="请输入金额" v-model="money" type="number"  auto-complete="off" style="width:120px"></el-input>
          元
        </el-form-item>
        <el-form-item label="核销次数" prop="number" v-if="mainList.vipID != -1 && isCode == 0" >
          <el-input size="small" placeholder="请输入次数" v-model="number"  auto-complete="off" style="width:120px"> </el-input>次
        </el-form-item> -->

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="sure()">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改备注" :visible.sync="noteShow" width="500px" @click="noteShow = false">
      <el-form label-width="120px" >
        <el-form-item label="备注:" prop="Note">
           <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="mainList.Note" ></el-input>
        </el-form-item>
      </el-form>
      <div class=" dilag-fix flex-r-x" >
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button
            style="margin-right:20px"
            size="small"
            type="primary"
            @click="sureNote()"
            >保存</el-button
          >
      </div>
    </el-dialog>
      
    <el-dialog title="业务归属" :visible.sync="show5" width="700px" @click="show5 = false" :close-on-click-modal="false">
      <div :key="timer" class="timer">
          <div class="css flexc-cen-x" v-for="(items,index) in ListPayOrderGS" style="width:100%;margin-top:5px;margin-bottom:2px" >
                  <div class="flex-xy " id="shadw" style="width:45%;margin-left:2%;border-radius:5px">
                      <div style="width:95%;padding-top:10px;padding-bottom:10px">
                          <div class="flex-spc-x"> 
                              <div class="flexc-cen-x">
                                  <i class="el-icon-s-unfold" style="font-size:15px"></i>
                                  <div style="font-size:15px;margin-left:7px">{{items.name}}<span v-if="items.Specname !=''">({{items.Specname}})</span></div>
                              </div>
                          <el-button type="text"  @click="toChoosePerson(items)">选择{{WZYGName}}</el-button>
                          </div>

                      </div>
                      
                  </div>
                  <div style="width:45%">
                      <div v-for="(item,index) in items.list" class="choosePerson flex-spc-x" style="margin-left:25px;width:100%">
                        <div style="width:80px">{{item.name}}</div>
                        <div class="flex-cen-x" >
                          <el-input size="mini" v-model="item.price" style="width:120px" @input="forceUpdate" placeholder="请输入内容"></el-input> 元
                        </div>
                        <div style="margin-left:12px">    
                          <el-button type="text"  icon="el-icon-delete" @click="deletePrice(index,items)"></el-button>
                        </div>
                    </div>
                  </div>
  
          </div> 
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="show5 = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="Sure1()">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="'选择'+WZYGName" :visible.sync="personShow" width="500px">
        <div class="dialogMain" style="width:100%;height:400px">
          <div class="flexc-cen-x" style="margin-bottom:10px">
              选择头衔：
            <el-select v-model="TitleID" clearable placeholder="请选择" size="mini">
                <el-option
                  v-for="item in unitList"
                  :key="item.ID"
                  :label="item.Title"
                  :value="item.ID">
                </el-option>
            </el-select>
             <el-button size="mini" style="margin-left:10px"   type="primary"  @click="getPersonList()">搜索</el-button>
          </div>

            <el-collapse>
                <el-collapse-item v-for="(items) in personList" :key="items.ID" >
                    <template slot="title">
                        <span style="margin-left:5px">{{items.Name}}</span>
                    </template>
                    <div class="cursor" v-for="item in items.listsub" :key="item.ID" style="margin-left:20px" @click="choose(item)" >
                        <div class="flexc-cen-x" style="margin-top:5px" :key="thier" > 
                            <img v-if="item.show == true" src="../../assets/icon/choose.png" alt="" style="width:18px;height:18px">
                             <img v-if="!item.show" src="../../assets/icon/nochoose.png" alt="" style="width:18px;height:18px">
                            <div style="margin-left:5px;font-size:15px">
                                {{item.Name}}
                            </div>
                        </div>   
                    </div>
                </el-collapse-item>
            </el-collapse>
          <div class=" dilag-fix flex-r-x" >
          <el-button size="small" @click="personShow = false">取消</el-button>
            <el-button
            style="margin-right:20px"
              size="small"
              type="primary"
        
          
              @click="surePerson()"
              >保存</el-button
            >
            </div>
        </div>
    </el-dialog>
    <!-- </el-dialog> -->

  </div>
</template>

<script>
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import CropperImage from "../../components/CropperImage";
import {getListManageLogin,addManageLogin,delManageLogin,editManageLogin,editManageLoginmoney,editManageLoginPwd,editManageLoginIsdisable} from "@/api/getData";
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      formValidate: {
        mainImage: "",
      },
      date:[],
      code:'',

  selectNmae:"",
  personShow:false,
      Note:'',
      Site:'',
      activeName: 'first',
      value:true,
      direction: "ltr",
      projectList:[],
      passShow:false,
       tdate:'',
      mdate:'',
      input:'',
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      chongShow:false,
      SelectStoresID:localStorage.getItem("StoresID"),
      title: '添加',
      tableData:[],
      Pwd:'',
      objID:'',
      site:'',
      mainList:[],
      DianList:[],
      hexiaoShow:false,
      LoginID:-1,
      OrderID:'',
    //   SelectStoresID:1,
      editForm: {
        LoginName:"",
        Phone:"",
        Name:"",
        pwd:"",
        money:"",
        ShopName:"",
        token: localStorage.getItem('token')
      },
      thier:'',
      money:1.00,
      personName:'',
      LoginIDs:'',
      personList:[],
      noteShow:false,
      // rules表单验证

      rules: {
        LoginName: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
          Phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
          Name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
          pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
          money: [{ required: true, message: '请输入余额', trigger: 'blur' }],
          ShopName: [{ required: true, message: '请输入商户名称', trigger: 'blur' }],
      },
      q1:false,
      q2:false,
      q3:false,
      show5:false,
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      TitleID:'',
      timer:'',
      unitList:[],
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      isCode:0,
      number:1,
      listGs:[],
      personShow:false,
      ListPayOrderGS:'',
      WZYGName:'',
      WZHYName:'',
      WZXMName:'',
      WZPBName:'',
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination,
     CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
    var date = new Date();
          var year = date.getFullYear();
          var month = date.getMonth() + 1;
          var day = date.getDate();
          if (month < 10) {
          month = '0' + month;
          }
          if (day < 10) {
          day = '0' + day;
          }
      if(localStorage.getItem('isAdmin') == 1){
          this.q1 = true
          this.q2 = true
          this.q3 = true
        
      }
  this.Limits = localStorage.getItem('Limits')
      this.Limits = this.Limits.split(',')
      this.Limits.forEach(items => {
          if(items == 142){
            this.q1 = true
          }
          if(items == 143){
            this.q2 = true
          }
          if(items == 144){
            this.q3 = true
          }

         
   })

      this.tdate = year + '-' + month + '-' + day;
      this.mdate = year + '-' + month + '-' + day;
      this.getList()
      this.getDianList()
      this.getSiteList()
      this.getProjectList()
      this.getPersonList()
      this.getUnitList()
      // this.ge1tList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getUnitList(){
       var data = { 
          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
      }
      var that = this
      this.ajax('getListStaffTitle.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {

                that.unitList = res.data   
                     
          } 
       })
    },
      forceUpdate () { 
    this.$forceUpdate() 
  },
  deletePrice(index,items){
    console.log(index)
    console.log(items)
    items.list.splice(index,1)
    this.timer = new Date().getTime()
  },
    choose(items){
      if(items.show){
              items.show = false
          } else {
              items.show = true
          }
           this.thier =  new Date().getTime()
      },
      surePerson(){
        var LoginIDs = []
          for(var i = 0;i<this.personList.length;i++){
              var items = this.personList[i].listsub
              for(var j = 0; j<items.length;j++){
                  if(items[j].show)
                  {
                      var  price = 0
                     this.items.list.forEach(item =>{
                       if(items[j].ID == item.ID){
                          price = item.price
                       }
                   })
                      var list = {
                          name:items[j].Name,
                          ID:items[j].ID,
                          price:price,
                      }
                    LoginIDs.push(list)
                  }
                  
              }
          }

          this.items.list = LoginIDs
          this.personShow = false
         
    },
    toChoosePerson(items){
       this.personList.forEach(item => {
                       item.listsub.forEach(it=>{
                       
                            
                            it.show = false
                    
                       })
              });
          this.items = items
          console.log(items)
          if(this.items.list){
            this.items.list.forEach(items => {
                 this.personList.forEach(item => {
                       item.listsub.forEach(it=>{
                          if(it.ID == items.ID){
                          
                            it.show = true
                          } 
                       })
              });
            });
           
              
          } else {
              this.items.list = []
          }
         
          this.personShow = true
    },

  
          getPersonList(){
           var data = { 
            SelectStoresID:this.SelectStoresID,
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
               Title:this.TitleID
         }
        var that = this
       this.ajax('getlistStaffgl.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.personList = res.data
               
            }

      })
      },

        
    toPerson(){
        this.personShow = true
    },
    toNote(row){
        
        this.mainList = row 
        this.mainList.addTime = this.mainList.addTime.replace(/\//g, '-')
        this.noteShow  =true
    },
    delDan(items){
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
             var data = {}
             var that = this
      data.SelectStoresID  = this.SelectStoresID 
      data.token = localStorage.getItem("token")
      data.StoresID=localStorage.getItem("StoresID")
      data.OrderID = items.ID
      this.ajax('delPayOrder.aspx',JSON.stringify(data),"POST",function(res){
                  if (res.orsuccess == "1") {
                    // that.gdCode = res.data
                        that.$message({
                            type: "success",
                            message: "删除成功",duration:2000,
                        });

                      that.getList()
                  }

            })
        })
        .catch(() => {
          
        })
    },
    sureNote(){
      var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          Note:this.mainList.Note,
          OrderID:this.mainList.ID,
        }
        var that = this
        this.ajax('editPayOrderNote.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "修改成功",duration:2000,
              });
             
              that.noteShow = false
      
              that.getList()
             
            }

        })
    },
    sure(){
      if(this.LoginIDs == ''){
        this.$message({ type: "error", message: "请选择" ,duration:1000});
                          return;
      }

    
      var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          OrderID:this.mainList.ID,
          StaffID:this.LoginIDs,
        }
        var that = this
        this.ajax('editPayOrderStaffID.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "修改成功",duration:2000,
              });
              that.LoginIDs = ''
              that.hexiaoShow = false
              // that.getType()
              that.getList()
              //  that.provinceList = res.data
            }

        })
    },
    hexiao(row){
      
      this.personName = row.StaffName
      this.mainList = row
      this.getListPayOrderGS()

      // this.iscode = 1
      // this.money = 0 
      // this.number = 0
    },
    getListPayOrderGS(){
        var data = { 
            SelectStoresID:this.SelectStoresID,        
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            OrderID:this.mainList.ID
          // StaffTypeID:this.active
      }

      
        var that = this
      this.ajax('getListPayOrderGS.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") { 
                var ListPayOrderGS = []
                that.payOrder = res.data
                  that.payOrder.forEach(items => {
                    var list1 = {
                      name: items.CommodityName,
                      Specname:items.Specname,
                      objID:items.objID,
                      objtype:items.objtype,
                      objPriceID:items.objPriceID,
                      list:[]
                    }
                    if(items.listsub.length>0){
                      var list = []
                         items.listsub.forEach(item =>{
                              var it = {
                                 name:item.StaffName,
                                  ID:item.StaffID,
                                  price:item.PriceTC,
                              }
                              list.push(it)
                         })
                   list1.list = list
                   }

                    ListPayOrderGS.push(list1)
                });
                  that.ListPayOrderGS = ListPayOrderGS
                that.show5 = true
              
          } 

      })
    },
    Sure1(){
      var listGs = []
      this.ListPayOrderGS.forEach(items => {
        if(items.list){
          items.list.forEach(item => {
                          var it = {
                            objtype:items.objtype,
                            objID:items.objID,
                            StaffID:item.ID,
                            PriceTC:item.price,
                            objPriceID:items.objPriceID
                          }
                          listGs.push(it)
                  });
          }
      });
 

       var data = { 
            SelectStoresID:this.SelectStoresID,        
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            OrderID:this.mainList.ID,
            OrderCode:this.mainList.OrderCode,
            ListPayOrderGS:listGs
          // StaffTypeID:this.active
      }

      
        var that = this
      this.ajax('editPayOrderGS.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.show5 = false
               that.$message({
                type: "success",
                message: "修改成功",duration:2000,
              });
          } 

      })
    },
     hexiao1(){
   
      this.hexiaoShow = true
      this.iscode = 1
      this.money = 0 
      this.number = 0
    },

     getProjectList(){
        var data = { 
            SelectStoresID:this.SelectStoresID,        
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            pages:1,
            psize:200,
            ProjectTypeID:0
          // StaffTypeID:this.active
      }

      
        var that = this
      this.ajax('getListProject.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {

                that.projectList = res.data
              
          } 

      })
      },
        getSiteList(){
       var data = { 
        SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:200,

      }
  
        var that = this
      this.ajax('getListSite.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
            
                that.siteList = res.data
      
          } 

      })
    },
     getDianList(){
       var data = { 
         SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
       this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.DianList =res.data
               
            }

      })
    },
    getList(){
      if(this.mdate < this.tdate){
        this.$message({ type: "error", message: "结束时间不得小于开始时间" ,duration:1000});
            return;
      }
        var data = { 
         SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          selectNmae:this.selectNmae,
          GMtime1:this.tdate,
          GMtime2:this.mdate,
          orderCode:'',
          OrderState:0,
          pages:this.formInline.page,
          psize:this.formInline.limit,
      }
        var that = this
       this.ajax('getListPayOrder.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
              res.data.forEach(items => {
                  items.addTime = items.addTime.replace(/\//g, '-')
              });
              that.tableData = res.data
              that.pageparm.total = res.allcount

            }
      })
    },



    handlePassword(row){
      // this.editForm.ManageLoginID = row.ID
      this.Pwd = ''
      this.passShow = true

    },
    handleChong(row){
      this.editForm.ManageLoginID = row.ID
      this.editForm.money = row.money
       this.chongShow = true
      this.money = ''
    },
    // 获取公司列表

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getList()
    },
    // 搜索事件
    
    search() {
      this.getList()
      
    },
    noSearch(){
        this.objID =''
        this.Site = ''
        this.LoginID = -1
        this.selectNmae = ''
        var date = new Date();
          var year = date.getFullYear();
          var month = date.getMonth() + 1;
          var day = date.getDate();
          if (month < 10) {
          month = '0' + month;
          }
          if (day < 10) {
          day = '0' + day;
          }
          var nowDate = 
        // this.data.[0] = 
      this.date[0] = year + '-' + month + '-' + day;
      this.date[1] = year + '-' + month + '-' + day;
        this.formInline.page = 1
      this.formInline.limit = 10
      this.pageparm={
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
      this.getList()
    },
    //显示编辑界面
    handleEdit: function(row) {
     
        var data = { 
         SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          OrderID:row.ID
        
      }
        var that = this
       this.ajax('getPayOrderInfo.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
              that.mainList  = res.data
               that.mainList.addTime = that.mainList.addTime.replace(/\//g, '-')
               that.editFormVisible = true
            }
      })
  
      

    },
    // 编辑、增加页面保存方法
    submitForm(editData) {

      this.$refs[editData].validate(valid => {
        if (valid) {
            if(this.title == '添加'){
                this.add()
            }else {
                this.edit()
            }
        } else {
          return false
        }
      })
    },



    handlejie(row) {
      if(row.Isdisable == 0){
 this.$confirm('确定要禁用吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            this.jie(row)
        })
        .catch(() => {
          
        })
      } else {
this.$confirm('确定要解禁吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            this.jie1(row)
        })
        .catch(() => {
          
        })
      }
 
     
    },

    todel(items){

      if(items.RowClassTypeqt == 1){ 
           this.$confirm("确定要取消预约吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { 
          SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          PreAboutID:items.ID,
          loginID:localStorage.getItem("LoginID"),
          Note:'',
        }
        var that = this
        this.ajax('editPreAboutStateQXQT.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "取消成功",duration:2000,
              });
        
              that.getList()
           
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
         
        });
   

           } else{
              this.$confirm("确定要取消预约吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = {
            SelectStoresID:this.SelectStoresID,
            StoresID:localStorage.getItem("StoresID"),
            token: localStorage.getItem("token"),
            PreAboutID:items.ID,
            loginID:localStorage.getItem("LoginID"),
            Note:'',
        }
        var that = this
        this.ajax('editPreAboutStateQX.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "取消成功",duration:2000,
              });
        
              that.getList()
         
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
          
        });
   

        }
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            this.delete(row)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.noteShow = false
      this.hexiaoShow = false,
      this.passShow = false,
      this.chongShow = false,
      this.editFormVisible = false
      this.personShow = false
    }
  }
}
</script>

<style scoped>
.dialogMain{
    overflow: auto;
}
.dilag-fix{
    position:absolute;
    right: 0;
    bottom: 0;
    margin-bottom: 10px;

}
.timer{
    max-height: 50vh;
    overflow: auto;
  }
.css{
  border-bottom: 1px solid #e9e9e9;
}
.bottomBORD{
  padding-bottom: 30px;
  width:100%;
  border-bottom: 1px solid #e9e9e9;
}

.main{
  position: absolute;
}
.content{
    font-size: 12px;
  color: #999;
  line-height: 20px;
}
.titleMain{
    font-size: 14px;
    color: #191919;
    line-height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.offline___NHq4e {
    position: absolute;
    top: -1px;
    right: -1px;
    padding: 0.5px 4px 0.5px 4px;
    /* width: 64px; */
    /* height: 22px; */
    background: rgba(255, 101, 247, 0.04);
    border-radius: 0 8px 0 8px;
    border: 1px solid rgba(187, 14, 255, 0.2);
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    color: #b336fc;
}
.box{
  position: relative;
    width: calc((100% - 80px)/4);
    padding: 20px;
    box-sizing: border-box;
    display: inline-block;
    margin-right: 16px;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
    height: 130px;
}
@media screen and ( max-width: 1400px ) {
  .box{
    cursor: pointer;
    width: calc((100% - 60px)/3);
  }
}
.box:hover{
  box-shadow: 0 4px 16px 0 rgb(0 0 0 / 16%);
}
.shadow:hover {
    border:1px solid #808080;border-radius:2px
}
.shadow {
    border:1px solid #ffffff;border-radius:2px
}

.xiang{
    padding: 1px 4px  1px 4px;
    background-color: #f7f7f7;
    border:1px solid #bbbbbb;
    border-radius: 3px;
    font-size: 10px;
    color:#bbbbbb;
}
  
/* .el-switch__core::after{
 height: 12px !important;
 width :12px !important;
} */
   
.title{
    margin-top: 10px;
    height: 30px;
    font-size: 13px;
    font-weight: bolder;
    border-radius: 3px;
    border-left: 5px solid #334157;

}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/Cashier/Cashier.vue